import {ApplicationRef, ComponentFactoryResolver, ComponentRef, Injectable, Injector} from '@angular/core';
import {Deck} from '@deck.gl/core';
import {Subject} from 'rxjs/Subject';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import * as mapboxgl from '@carto/mapbox-gl';
import {HttpClient} from './http.client';
import {FlyToInterpolator, WebMercatorViewport} from '@deck.gl/core';

@Injectable()
export class MapContextService {
    mapInstance: any;
    deckInstance: Deck;
    bboxChange: Subject<any> = new Subject<any>();
    public mobilePopup = new Subject<any>();
    public listenerLayerLoading = new Subject();
    private loadingList = [];
    onViewStateChange = new Subject();
    onViewRender = new Subject();
    mapLoaded: Subject<any> = new BehaviorSubject<any>(null);
    private elementsForPopup = [];
    private elementsForPopupSubject = new Subject<Array<any>>();
    elementsForPopup$ = this.elementsForPopupSubject.asObservable();
    compRef: ComponentRef<any>;
    popup: any;
    _bbox: any;
    currentMapEvent = new Subject();
    _coordinates: any;

    constructor(
        private resolver: ComponentFactoryResolver,
        private injector: Injector,
        private appRef: ApplicationRef,
        private http: HttpClient
    ) {
    }

    loadPopup(popup) {
        this.elementsForPopup.push(popup);
        this.elementsForPopupSubject.next(this.elementsForPopup);
    }

    closePopup() {
        this.elementsForPopup = [];
        this.elementsForPopupSubject.next(this.elementsForPopup);
        if (this.popup) {
            this.popup.remove();
        }
    }

    loadMobilePopup(html) {
        this.mobilePopup.next(html);
    }

    addToLoading(layer) {
        this.loadingList.push(layer);
        this.listenerLayerLoading.next(this.loadingList);
    }

    openPopup(popups) {
        if (!Array.isArray(popups) || !popups.length) {
            return;
        }
        if (window.innerWidth <= 600) {
            this.loadMobilePopup(this.generatePopup(popups[popups.length - 1].template, popups[popups.length - 1].properties));
            this.closePopup();
        } else {
            const content = this.generatePopup(popups[popups.length - 1].template, popups[popups.length - 1].properties);
            if (!this.popup) {
                this.popup = new mapboxgl.Popup({
                    closeOnClick: true
                });
            }

            this.popup.setLngLat([popups[popups.length - 1].coordinates.lng, popups[popups.length - 1].coordinates.lat])
                .setDOMContent(content)
                .addTo(this.mapInstance);
        }
    }

    removeFromLoading() {
        this.loadingList.pop();
        this.listenerLayerLoading.next(this.loadingList);
    }

    generatePopup(popup, properties) {
        const cmpFactory = this.resolver.resolveComponentFactory(popup);
        this.compRef = cmpFactory.create(this.injector);
        this.compRef.instance.properties = properties;
        this.appRef.attachView(this.compRef.hostView);
        return this.compRef.location.nativeElement;
    }

    getMapStyle() {
        return this.http.get('/assets/mapstyle/style.json').map(e => {
            const response = e.json();
            response['sprite'] = window.location.origin + response['sprite'];
            response['sources']['openmaptiles']['url'] = window.location.origin + response['sources']['openmaptiles']['url'];
            return response;
        }).toPromise();
    }

    getViewState(map) {
        const {latitude, longitude, zoom, pitch, bearing} = map.getViewports()[0];
        return {latitude, longitude, zoom, pitch, bearing};
    }

    zoomIn(params: any = {}) {
        const {duration = 200, speed} = params;
        const viewState = this.getViewState(this.deckInstance);
        const zoom = viewState.zoom + 1;
        this.deckInstance.setProps({
            viewState: {
                ...viewState,
                zoom: zoom,
                transitionDuration: duration || undefined,
                transitionInterpolator: duration ? new FlyToInterpolator({speed}) : undefined
            }
        });
    }

    zoomOut(params: any = {}) {
        const {duration = 200, speed} = params;
        const viewState = this.getViewState(this.deckInstance);
        const zoom = viewState.zoom - 1;
        this.deckInstance.setProps({
            viewState: {
                ...viewState,
                zoom: zoom,
                transitionDuration: duration || undefined,
                transitionInterpolator: duration ? new FlyToInterpolator({speed}) : undefined
            }
        });
    }

    flyTo(center: any) {
        const viewState = this.getViewState(this.deckInstance);
        const zoom = 11;
        this.deckInstance.setProps({
            viewState: {
                ...viewState,
                zoom: zoom,
                longitude: center[0],
                latitude: center[1],
                // transitionDuration: 200,
                // transitionInterpolator: new FlyToInterpolator(100)
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/common/map-context.service.ts